









































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import EventBus from '@/communication/EventBus';
import OdataResource from '@/modules/api/OdataResource';
import IFormField from '@/modules/form/interfaces/IFormField';
import IPaymentRequest from '@/modules/form/interfaces/IPaymentRequest';
import IPaymentStatusUpdateRequest from '@/modules/form/interfaces/IPaymentStatusUpdateRequest';
import { convertNoCommaAmountToNumber } from '@/utils/payment';
import { VueTimersMixin, Timer } from 'vue-plugin-timers';

@Component({
    name: 'PaymentRestForm',
    components: {},
    mixins: [VueTimersMixin],
})
export default class PaymentRestForm extends Vue {
    @Prop() public formField!: IFormField;
    @Prop() public keyId!: number;
    @Prop() public eventId!: number;
    @Prop() public eventTypeId!: number;
    @Prop() public keyGuid!: string;
    @Getter('apiUrl', { namespace: 'configuration' }) private apiUrl!: string;
    private readonly PaymentRequests = this.apiUrl + '/odata/registrations/PaymentRequests';
    private paymentRequestResource: OdataResource<IPaymentRequest> = new OdataResource<IPaymentRequest>(
        this.PaymentRequests,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
    );
    private readonly PaymentStatusUpdateRequests = this.apiUrl + '/odata/registrations/PaymentStatusUpdateRequests';
    private paymentStatusUpdateRequestResource: OdataResource<IPaymentStatusUpdateRequest> = new OdataResource<
        IPaymentStatusUpdateRequest
    >(this.PaymentStatusUpdateRequests, this.onResourceLoading, this.onResourceLoadingFinished, this.onError);
    private errored = false;
    private loading = false;
    private paymentRequest: IPaymentRequest = {} as IPaymentRequest;
    private paymentLink: string | undefined;
    private orderId: string | undefined;

    @Timer({ interval: 5000, repeat: true })
    paymentChecking() {
        this.checkPaymentStatus();
    }

    private async mounted() {
        this.$timers.stop('paymentChecking');
        this.paymentRequestResource.$on('resourceCreated', this.onPaymentRequestCreated);
        this.paymentStatusUpdateRequestResource.$on('resourceCreated', this.onPaymentStatusUpdateRequestCreated);

        await this.requestNewPayment();
    }

    private get amount() {
        const amount = convertNoCommaAmountToNumber(this.paymentRequest?.Amount);
        return amount.toFixed(2);
    }

    private get clientIp() {
        let clientIp = localStorage.getItem('clientIp');
        if (clientIp === undefined || clientIp === null || clientIp === '' || clientIp === 'undefined') {
            clientIp = '127.0.0.1'; // fake IP in case of issuses with getting parameter that is required for the payent
        }

        return clientIp;
    }

    private isZero(amount: string) {
        const value = +amount as number;
        return value === 0;
    }

    private async requestNewPayment() {
        const paymentRequest = {
            EventRegistrationId: this.keyId,
            EventRegistrationGuid: this.keyGuid,
            ClientIp: this.clientIp,
            PosType: 'REST',
            ContinueUrl: `${window.location.origin}${window.location.pathname}?i=${this.keyId}&g=${this.keyGuid}&c=true`,
        };
        this.paymentRequestResource.baseUrl = this.apiUrl + '/odata/registrations/PaymentRequests';
        const paymentOrder: IPaymentRequest | undefined = await this.paymentRequestResource.createNewResource(
            paymentRequest,
        );
        if (paymentOrder) {
            this.paymentLink = paymentOrder.RedirectUri;
        }
    }

    private async checkPaymentStatus() {
        const paymentStatusUpdateRequest: IPaymentStatusUpdateRequest = {
            OrderId: this.orderId,
        };
        this.paymentStatusUpdateRequestResource.baseUrl =
            this.apiUrl + '/odata/registrations/PaymentStatusUpdateRequests';
        const paymentRequestResult = await this.paymentStatusUpdateRequestResource.createNewResource(
            paymentStatusUpdateRequest,
        );
        if (paymentRequestResult !== undefined && paymentRequestResult.Status === 'CANCELED') {
            this.requestNewPayment();
        }
    }

    private onSubmit(): void {
        // Redirect to form so symulate return form payment site
        const route = this.$router.resolve({
            name: 'form',
        });
        const path = `${route.href}?e=${this.eventId}&session_id=${this.paymentRequest.SessionId}&pos_id=${this.paymentRequest.PosId}&amountPS=0&payType=c`;
        this.$router.push(path);
        location.reload();
    }

    private onPay(): void {
        if (this.paymentLink) {
            window.open(this.paymentLink, '_blank');

            // start checking payment status
            this.$timers.start('paymentCheckig');
        }
    }

    private onError(error: object) {
        console.error(error);
        this.errored = true;
    }

    private onPaymentRequestCreated(paymentRequest: IPaymentRequest) {
        this.paymentRequest = paymentRequest;
        this.orderId = paymentRequest.OrderId;

        const userPaymentSessionData = {
            SessionId: paymentRequest.SessionId,
            EventRegistrationId: paymentRequest.EventRegistrationId,
            EventRegistrationGuid: paymentRequest.EventRegistrationGuid,
            EventId: this.eventId,
            EventTypeId: this.eventTypeId,
        };
        const userPaymentSessionDataJson = JSON.stringify(userPaymentSessionData);
        localStorage.setItem('paymentRequest' + paymentRequest.SessionId?.toString(), userPaymentSessionDataJson);
    }

    private onPaymentStatusUpdateRequestCreated(paymentStatusUpdateRequest: IPaymentStatusUpdateRequest) {
        if (paymentStatusUpdateRequest.Status === 'COMPLETED') {
            this.$timers.stop('paymentCheckig');
            if (this.keyId && this.keyGuid) {
                EventBus.$emit('paymentCompleated', { eventId: this.keyId, eventGuid: this.keyGuid });
            }
        }
    }

    private onResourceLoading() {
        this.loading = true;
    }

    private onResourceLoadingFinished() {
        this.loading = false;
    }
}
